export const loadingConfig = {
  shelvesLoading: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.logos/vlinder-logo.png',
    titleNormalText: 'Loading',
    titleBoldText: 'Shelves...',
    description: 'This might take few seconds, Please wait !',
  },
};
